/**
 * THC-ban PDP (c-new-pdp, section setting "THC ban mode").
 *
 * - Countdowns: every [data-thc-clock] ticks to its data-deadline (unix seconds). Once it runs out,
 *   anything marked [data-thc-hide-expired] is hidden.
 * - Supply ladder: a rung is N jars of the selected dose. Rung, purchase type and the quantity stepper
 *   drive the rung prices, the title price, the per-serving figure, the add-to-cart price, and the
 *   hidden quantity / selling_plan inputs that product-form.js posts.
 * - Pack mode (drinks, [data-pack-position]): a rung is a value of the pack option (6 / 12 / 24 cans),
 *   i.e. its own variant at its own price, quantity 1. Picking a rung picks that value in the
 *   hidden picker row, so product-info.js swaps the variant the usual way.
 * - A/B arm: 1/3/12 by default, 1/6/12 when <html> carries .thc-ladder-6. The arm comes from
 *   ?ladder=3|6 (QA, wins), the html class, or the CSS variable --thc-supply-ladder: 6 that the
 *   Intelligems experiment injects. Intelligems can land after this script, so the arm is re-read
 *   for a few seconds until the shopper touches the ladder.
 * - Reviews: the card matching the selected dose is shown, swapped on the click itself.
 */
(function () {
  if (window.__thcBanPdp) return;
  var api = (window.__thcBanPdp = { arm: '3' });

  /* ---------------------------------------------------------------- countdowns */

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tick() {
    var now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-thc-clock]').forEach(function (clock) {
      var left = Math.max(0, parseInt(clock.dataset.deadline, 10) - now);
      var d = Math.floor(left / 86400);
      var h = Math.floor((left % 86400) / 3600);
      var m = Math.floor((left % 3600) / 60);
      var s = left % 60;
      var inline = clock.classList.contains('thc-clock--inline');
      var values = { d: inline ? pad(d) : String(d), h: inline ? pad(h) : String(h), m: inline ? pad(m) : String(m), s: inline ? pad(s) : String(s) };
      clock.querySelectorAll('[data-unit]').forEach(function (el) {
        var v = values[el.dataset.unit];
        if (el.textContent !== v) el.textContent = v;
      });
      clock.classList.toggle('is-final-day', d === 0);
      if (left === 0) {
        var scope = clock.closest('[data-thc-hide-expired]');
        if (scope) scope.hidden = true;
      }
    });
    document.querySelectorAll('[data-thc-days]').forEach(function (el) {
      var clock = el.closest('[data-thc-hide-expired]') && el.closest('[data-thc-hide-expired]').querySelector('[data-thc-clock]');
      if (!clock) return;
      var days = String(Math.floor(Math.max(0, parseInt(clock.dataset.deadline, 10) - now) / 86400));
      if (el.textContent !== days) el.textContent = days;
    });
  }

  /* ---------------------------------------------------------------- A/B arm */

  function readArm() {
    var param = new URLSearchParams(window.location.search).get('ladder');
    if (param === '6' || param === '3') return param;
    var html = document.documentElement;
    // The CSS variable goes before the class: applyArm sets the class itself, and on a page that
    // starts on 1/6/12 a late Intelligems injection of --thc-supply-ladder: 3 still has to win.
    var cssVar = getComputedStyle(html).getPropertyValue('--thc-supply-ladder').trim();
    if (cssVar === '6' || cssVar === '3') return cssVar;
    if (html.classList.contains('thc-ladder-6')) return '6';
    return document.querySelector('[data-default-arm="6"]') ? '6' : '3';
  }

  function applyArm(arm) {
    api.arm = arm;
    document.documentElement.classList.toggle('thc-ladder-6', arm === '6');
    document.documentElement.classList.toggle('thc-ladder-3', arm === '3');
  }

  /* ---------------------------------------------------------------- buy box */

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var noDecimals = String(Math.round(cents / 100));
    return (format || '${{amount}}')
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount}}', amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function initBuyBox(box) {
    var sectionId = box.dataset.sectionId;
    var productInfo = box.closest('product-info') || document;
    var format = box.dataset.moneyFormat;
    var servings = parseInt(box.dataset.servings, 10) || 30;
    var planId = parseInt(box.dataset.planId, 10) || null;
    var subscribeTitle = box.dataset.subscribeTitle || '';
    var rungs = Array.prototype.slice.call(box.querySelectorAll('[data-thc-rung]'));
    var planPanel = box.querySelector('[data-thc-plan]');
    var qtyHidden = box.querySelector('[data-thc-quantity]');
    var planHidden = box.querySelector('[data-thc-selling-plan]');
    var idHidden = box.querySelector('input[name="id"]');
    var stepper = box.querySelector('.quantity__input');
    var submitPrice = box.querySelector('[data-product-form-submit-price]');
    var packIndex = (parseInt(box.dataset.packPosition, 10) || 0) - 1;
    var packOption = box.dataset.packOption || '';
    var variants = [];
    var touched = false;
    var variant = null;

    try {
      variant = JSON.parse(box.querySelector('[data-thc-variant]').textContent);
    } catch (e) {}
    if (packIndex >= 0) {
      try {
        variants = JSON.parse(box.querySelector('[data-thc-variants]').textContent);
      } catch (e) {}
    }

    function selectedRung() {
      var input = box.querySelector('.thc-supply__input:checked');
      return input ? input.closest('[data-thc-rung]') : null;
    }

    function rungVisible(rung) {
      var arm = rung.dataset.arm;
      return arm === 'all' || arm === api.arm;
    }

    function selectMonths(months) {
      rungs.forEach(function (rung) {
        rung.querySelector('.thc-supply__input').checked = rung.dataset.months === String(months);
      });
    }

    // Pack mode: the variant a rung stands for is the selected one with its pack value swapped.
    function rungVariant(rung) {
      if (packIndex < 0) return variant;
      if (!variant) return null;
      var want = rung.dataset.packValue;
      for (var i = 0; i < variants.length; i++) {
        var options = variants[i].options;
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (j === packIndex ? options[j] !== want : options[j] !== variant.options[j]) {
            match = false;
            break;
          }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function syncPackRung() {
      if (packIndex < 0 || !variant) return;
      rungs.forEach(function (rung) {
        rung.querySelector('.thc-supply__input').checked = rung.dataset.packValue === variant.options[packIndex];
      });
    }

    // Keeps the hidden picker row on the rung's value. With `notify`, product-info.js hears it and
    // swaps the variant; without, the row just stops lying (a landing with no ?variant= starts on
    // the design's default pack while the picker was rendered on the first variant).
    function pickPackValue(value, notify) {
      var row = productInfo.querySelector('variant-selects');
      if (!row) return;
      var radios = row.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        var radio = radios[i];
        if (radio.name.indexOf(packOption + '-') !== 0 || radio.value !== value) continue;
        if (!radio.checked) {
          radio.checked = true;
          if (notify) radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }

    function planMode() {
      var input = box.querySelector('.thc-plan__input:checked');
      return input ? input.value : 'onetime';
    }

    function allocation(forVariant) {
      var list = (forVariant && forVariant.selling_plan_allocations) || [];
      for (var i = 0; i < list.length; i++) {
        if (!planId || list[i].selling_plan_id === planId) return list[i];
      }
      return null;
    }

    // Checkout takes the % off each jar and drops the fraction of a cent.
    function jarPrice(cents, pct) {
      return cents - Math.floor((cents * pct) / 100);
    }

    function rungPrice(rung) {
      var base;
      var price;
      var pct = parseInt(rung.dataset.pct, 10) || 0;
      if (packIndex >= 0) {
        var v = rungVariant(rung);
        base = v ? v.price : 0;
        price = jarPrice(base, pct);
      } else {
        var months = parseInt(rung.dataset.months, 10);
        base = variant.price * months;
        price = jarPrice(variant.price, pct) * months;
      }
      return { base: base, price: price, pct: pct };
    }

    // Checkout discounts by jars in the cart, so 3-month x2 is priced on the 6-jar tier, whichever
    // arm is showing. Tier = the largest rung that the total quantity reaches.
    function tierPct(jars) {
      var pct = 0;
      var reached = 0;
      rungs.forEach(function (r) {
        var months = parseInt(r.dataset.months, 10);
        if (months <= jars && months >= reached) {
          reached = months;
          pct = parseInt(r.dataset.pct, 10) || 0;
        }
      });
      return pct;
    }

    function setText(el, text) {
      if (el && el.textContent !== text) el.textContent = text;
    }

    function render() {
      if (!variant) return;
      var rung = selectedRung();
      if (!rung || !rungVisible(rung)) {
        selectMonths(api.arm);
        rung = selectedRung();
      }
      if (!rung) return;

      rungs.forEach(function (r) {
        var p = rungPrice(r);
        setText(r.querySelector('[data-thc-rung-price]'), formatMoney(p.price, format));
        var compare = r.querySelector('[data-thc-rung-compare]');
        setText(compare, formatMoney(p.base, format));
        if (compare) compare.hidden = p.pct === 0;
      });

      var pack = packIndex >= 0;
      var months = pack ? 1 : parseInt(rung.dataset.months, 10);
      var buying = pack ? rungVariant(rung) || variant : variant;
      var firstRung = pack ? rung === rungs[0] : months === 1;
      var alloc = allocation(buying);
      var isSubscription = firstRung && !!alloc && planMode() === 'subscribe';
      var current = rungPrice(rung);
      var unit = current.price;
      var compareAt = current.base;
      var pct = current.pct;

      if (planPanel) {
        planPanel.hidden = !(firstRung && alloc);
        setText(box.querySelector('[data-thc-plan-onetime]'), formatMoney(current.price, format));
        var oneCompare = box.querySelector('[data-thc-plan-onetime-compare]');
        setText(oneCompare, formatMoney(current.base, format));
        if (oneCompare) oneCompare.hidden = current.pct === 0;
        if (alloc) {
          var subPct = Math.round(((buying.price - alloc.price) / buying.price) * 100);
          setText(box.querySelector('[data-thc-plan-subscribe]'), formatMoney(alloc.price, format));
          setText(box.querySelector('[data-thc-plan-subscribe-title]'), subscribeTitle.replace('[percent]', subPct));
        }
      }
      if (isSubscription) {
        unit = alloc.price;
        compareAt = buying.price;
        pct = Math.round(((buying.price - alloc.price) / buying.price) * 100);
      }

      productInfo.querySelectorAll('[data-thc-title-price]').forEach(function (row) {
        setText(row.querySelector('[data-thc-tp-price]'), formatMoney(unit, format));
        var c = row.querySelector('[data-thc-tp-compare]');
        setText(c, formatMoney(compareAt, format));
        if (c) c.hidden = pct === 0;
        var save = row.querySelector('[data-thc-tp-save]');
        setText(save, 'Save ' + pct + '%');
        if (save) save.hidden = pct === 0;
      });

      var perServe = productInfo.querySelector('[data-cro-per-serve]');
      var servingsInRung = pack ? parseInt(rung.dataset.packValue, 10) || 1 : months * servings;
      setText(perServe, '(' + formatMoney(Math.round(unit / servingsInRung), format) + '/serving)');

      // A subscription is one jar a month, so the stepper stays at 1 while subscribe is picked.
      // product-info.js drops max on variant change; its quantityUpdate re-runs this.
      if (stepper) {
        if (isSubscription) {
          stepper.max = '1';
          if (stepper.value !== '1') stepper.value = '1';
        } else {
          stepper.removeAttribute('max');
        }
        var plus = stepper.parentElement.querySelector('.quantity__button[name="plus"]');
        if (plus) plus.classList.toggle('disabled', isSubscription);
      }

      var multiplier = Math.max(1, parseInt(stepper && stepper.value, 10) || 1);
      var jars = months * multiplier;
      var total;
      if (isSubscription || pack) {
        total = unit * multiplier;
      } else {
        total = jarPrice(variant.price, tierPct(jars)) * jars;
      }
      if (qtyHidden) qtyHidden.value = String(jars);
      if (pack && idHidden && buying && idHidden.value !== String(buying.id)) idHidden.value = String(buying.id);
      if (planHidden) {
        if (isSubscription) {
          planHidden.name = 'selling_plan';
          planHidden.value = String(alloc.selling_plan_id);
        } else {
          planHidden.removeAttribute('name');
          planHidden.value = '';
        }
      }
      if (submitPrice) setText(submitPrice, ' • ' + formatMoney(total, format));

      api.months = months;
      api.subscribe = isSubscription;
      api.quantity = jars;
      api.total = total;
    }

    box.addEventListener('change', function (event) {
      if (event.target.matches('.thc-supply__input, .thc-plan__input')) touched = true;
      if (packIndex >= 0 && event.target.matches('.thc-supply__input')) {
        pickPackValue(event.target.value, true);
      }
      render();
    });

    // The variant-change event only lands after product-info.js re-fetches the section, so the
    // review follows the radio as soon as it is picked (pills, dose tabs and the sticky bar all
    // end in a change on these radios).
    productInfo.addEventListener('change', function (event) {
      if (event.target.matches && event.target.matches('variant-selects input[type="radio"]')) {
        showReview(productInfo, event.target.value);
      }
    });

    if (stepper) stepper.addEventListener('change', render);

    // Belt and braces: recompute right before product-form.js reads the inputs.
    document.addEventListener(
      'submit',
      function (event) {
        if (event.target && event.target.id === 'product-form-' + sectionId) render();
      },
      true
    );

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var next = event && event.data && event.data.variant;
        if (!next || (event.data.sectionId && event.data.sectionId !== sectionId)) return;
        variant = next;
        syncPackRung();
        render();
        showReview(productInfo, next.option1);
      });
      // product-info.js resets the stepper to its minimum on variant change without a change event.
      subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
        setTimeout(render, 0);
      });
    }

    if (packIndex >= 0 && variant) pickPackValue(variant.options[packIndex], false);

    api.render = render;
    api.isTouched = function () {
      return touched;
    };
    render();
  }

  /* ---------------------------------------------------------------- option info */

  // "Choose your dose" info icons (drinks) sit in the picker, which product-info.js re-renders on
  // every variant change, so they are handled from the document.
  function onInfoClick(event) {
    var button = event.target.closest && event.target.closest('[data-thc-info]');
    document.querySelectorAll('[data-thc-info-pop]').forEach(function (pop) {
      var owner = pop.previousElementSibling;
      if (button && owner === button) {
        pop.hidden = !pop.hidden;
        button.setAttribute('aria-expanded', String(!pop.hidden));
      } else if (!pop.hidden) {
        pop.hidden = true;
        if (owner) owner.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------------------------------------------------------------- reviews */

  function showReview(scope, doseName) {
    var dose = String(doseName || '').toLowerCase().trim();
    scope.querySelectorAll('[data-thc-reviews]').forEach(function (wrap) {
      var cards = wrap.querySelectorAll('[data-thc-review]');
      var match = Array.prototype.some.call(cards, function (card) {
        return card.dataset.dose === dose;
      });
      cards.forEach(function (card, index) {
        card.hidden = match ? card.dataset.dose !== dose : index !== 0;
      });
    });
  }

  /* ---------------------------------------------------------------- boot */

  function boot() {
    applyArm(readArm());
    document.querySelectorAll('[data-thc-buy]').forEach(initBuyBox);
    document.addEventListener('click', onInfoClick);
    tick();
    setInterval(tick, 1000);

    // Intelligems may inject its CSS after this runs. Keep re-reading the arm for 15s
    // (Date-based: background tabs throttle intervals) unless the shopper already chose a rung.
    var until = Date.now() + 15000;
    var poll = setInterval(function () {
      var arm = readArm();
      if (arm !== api.arm && !(api.isTouched && api.isTouched())) {
        applyArm(arm);
        if (api.render) api.render();
      }
      if (Date.now() > until) clearInterval(poll);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
